import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import WhatWeOffer from './components/WhatWeOffer';
import TrustSection from './components/TrustSection';
import FinalCta from './components/FinalCta';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import Calculator from './pages/Calculator';
import Loans from './pages/Loans';
import ComingSoon from './pages/ComingSoon';
import Footer from './components/Footer';
import SEO from './components/SEO';
import './styles/base.css'; // ← global styles


function Home() {
  return (
    <>
      <Hero />
      <HowItWorks />
      <WhatWeOffer />
      <TrustSection />
      <FinalCta />
    </>
  );
}

// Add this CSS to your App.css or a global CSS file
const appStyles = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  position: 'relative',
};

const mainStyles = {
  flex: '1 0 auto',
  width: '100%',
  position: 'relative',
  zIndex: 1,
};

export default function App() {
  const location = useLocation();

  return (
    <div className="app" style={appStyles}>
      <SEO pathname={location.pathname} />
      <Navbar />
      <main style={mainStyles}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/loans" element={<Loans />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
